import ClipLoader from 'react-spinners/ClipLoader';

export const Spinner = ({ loading }) => {
  return (
    <div className="h-[40px] w-[40px] mx-auto">
      <ClipLoader color="#63A6FA" loading={loading} size={28} />
    </div>
  );
};
